import { createFileRoute } from '@tanstack/react-router';
import LostLoginPage from '@features/auth/lost-login.tsx';

export const Route = createFileRoute('/lost-login')({
  component: LostLoginPage,
});
